import React, { useEffect, useState } from 'react';
import { getFetchRequest, postFetchRequest } from '../store/requests';
import { makeUrl, errorCallback } from '../constant';
import { ErrorHandler } from './ErrorHandler';
import { PlusIcon } from '../appearence/icons/plus_icon';
import { MinusIcon } from '../appearence/icons/minus_icon';

const SelectChevron = () => (
    <svg className="order-header__icon" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" stroke="#666666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const StocksTab = ({ isCollapsed }) => {
    const [customStockNames, setCustomStockNames] = useState('');
    const [customStockCoefs, setCustomStockCoefs] = useState([{ name: '', coef: '' }]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [addNewCategoryIsOpen, setAddNewCategoryIsOpen] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [selectedParentCategory, setSelectedParentCategory] = useState('');
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [categoryNamePlural, setCategoryNamePlural] = useState('');
    const [categoryNameSingular, setCategoryNameSingular] = useState('');
    const [deleteCategoryId, setDeleteCategoryId] = useState('');



    // Колбэк получения заблокированных складов
    const successGetBlockedStocks = (response) => {
        if (Array.isArray(response.names)) {
            setCustomStockNames(response.names.join(', '));
        }
    };

    // Колбэк получения коэффициентов складов
    const successGetStockCoefs = (response) => {
        if (response && typeof response === 'object') {
            const entries = Object.entries(response).map(([name, coef]) => ({ name, coef: String(coef) }));
            setCustomStockCoefs(entries.length ? entries : [{ name: '', coef: '' }]);
        }
    };

    const handleAddCategory = (e) => {
        e.preventDefault();
        if (!newCategoryName) return;
        
        const categoryData = {
            name: newCategoryName,
            parent_id: selectedParentCategory || null
        };

        postFetchRequest(
            makeUrl(['/api/v1/category/']),
            categoryData,
            (response) => {
                // Вместо ручного добавления - перезагружаем весь список
                getFetchRequest(
                    makeUrl(['/api/v1/category/']),
                    (updatedCategories) => {
                        setCategoriesList(updatedCategories);
                        setAddNewCategoryIsOpen(false);
                        setNewCategoryName('');
                        setSelectedParentCategory('');
                    },
                    errorCallback
                );
            },
            (error) => alert(`Ошибка: ${error.message}`)
        );
    };

    const fetchCategories = () => {
        getFetchRequest(
            makeUrl(['/api/v1/category/']),
            (response) => setCategoriesList(response || []),
            errorCallback
        );
    };

    const handleSelectCategory = (categoryId, categories) => {
        setSelectedCategoryId(categoryId);
        const category = categories.find((item) => item.id === categoryId);
        setCategoryNamePlural(category ? category.name : '');
        setCategoryNameSingular(category ? category.singular : '');
    };

    const showCategorySaveError = (error) => {
        let message = error && error.message ? error.message : 'Не удалось сохранить название';
        try {
            const parsed = JSON.parse(message);
            if (parsed && parsed.error) {
                message = parsed.error;
            }
        } catch (parseError) {
            // ответ сервера уже текстовый
        }
        alert(message);
    };

    const handleDeleteCategory = (event) => {
        if (event) {
            event.preventDefault();
        }
        const category = flatCategories.find((item) => item.id === deleteCategoryId);
        if (!category) {
            alert('Выберите категорию');
            return;
        }
        if (!window.confirm(`Удалить категорию «${category.label}»?`)) {
            return;
        }
        postFetchRequest(
            makeUrl(['/api/v1/category/del/']),
            { id: deleteCategoryId },
            () => {
                alert('Категория удалена');
                if (selectedCategoryId === deleteCategoryId) {
                    setSelectedCategoryId('');
                    setCategoryNamePlural('');
                    setCategoryNameSingular('');
                }
                setDeleteCategoryId('');
                fetchCategories();
            },
            showCategorySaveError
        );
    };

    const handleUpdateCategoryName = (event) => {
        if (event) {
            event.preventDefault();
        }
        if (!selectedCategoryId) {
            alert('Выберите категорию');
            return;
        }
        if (!categoryNamePlural.trim()) {
            alert('Введите название во множественном числе');
            return;
        }

        postFetchRequest(
            makeUrl(['/api/v1/category/update/']),
            {
                id: selectedCategoryId,
                name: categoryNamePlural.trim(),
                nameSingular: categoryNameSingular.trim(),
            },
            () => {
                alert('Название категории обновлено');
                fetchCategories();
            },
            showCategorySaveError
        );
    };



    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        // Загружаем заблокированные названия складов
        postFetchRequest(
            makeUrl(['/api/v1/product/get-stocks/']),
            {},
            successGetBlockedStocks,
            errorCallback
        );
        // Загружаем коэффициенты складов
        getFetchRequest(
            makeUrl(['/api/v1/product/get-stocks-coef/']),
            successGetStockCoefs,
            errorCallback
        );
    }, []);

    // Отправка пользовательских названий складов
    const sendCustomStockNames = () => {
        const names = customStockNames.split(',').map(n => n.trim()).filter(Boolean);
        if (!names.length) {
            alert('Введите хотя бы одно название');
            return;
        }
        postFetchRequest(
            makeUrl(['/api/v1/product/custom-stocks/']),
            { names },
            () => {
                alert('Названия складов отправлены');
                setCustomStockNames('');
            },
            errorCallback
        );
    };

    // Добавление новой строки коэффициентов
    const handleAddCoefRow = () => {
        setCustomStockCoefs([...customStockCoefs, { name: '', coef: '' }]);
    };

    // Удаление строки коэффициентов
    const handleRemoveCoefRow = (index) => {
        if (customStockCoefs.length > 1) {
            setCustomStockCoefs(customStockCoefs.filter((_, i) => i !== index));
        }
    };

    // Обновление полей коэффициентов
    const handleChangeCoef = (index, field, value) => {
        const updated = [...customStockCoefs];
        updated[index][field] = value;
        setCustomStockCoefs(updated);
    };

    // Отправка коэффициентов на сервер
    const handleSendCoefs = () => {
        const dict = customStockCoefs.reduce((acc, { name, coef }) => {
            if (name && coef) acc[name] = coef;
            return acc;
        }, {});
        if (!Object.keys(dict).length) {
            alert('Добавьте хотя бы одну пару "название-коэффициент"');
            return;
        }
        postFetchRequest(
            makeUrl(['/api/v1/product/custom-stocks-coef/']),
            dict,
            () => alert('Коэффициенты успешно отправлены'),
            errorCallback
        );
    };

    const categoryOptionLabel = (name, productsNumber) => {
        const count = Number(productsNumber);
        const safeCount = Number.isFinite(count) ? count : 0;
        return `${name} (${safeCount})`;
    };

    const compareCategoryNames = (left, right) =>
        String(left?.categoryName || '').localeCompare(String(right?.categoryName || ''), 'ru', { sensitivity: 'base' });

    const sortedCategories = [...categoriesList].sort(compareCategoryNames);

    const flatCategories = sortedCategories.flatMap(parent => [
        {
            id: parent.categoryId,
            name: parent.categoryName,
            singular: parent.categoryNameSingular || '',
            label: categoryOptionLabel(parent.categoryName, parent.productsNumber),
        },
        ...[...(parent.subCategories || [])].sort(compareCategoryNames).map(sub => ({
            id: sub.categoryId,
            name: sub.categoryName,
            singular: sub.categoryNameSingular || '',
            label: categoryOptionLabel(`${parent.categoryName} / ${sub.categoryName}`, sub.productsNumber),
        })),
    ]);

    try {
        return (
            <section className={`workspace ${isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'} calendar-settings__page`}>
                <div className="site-info">
                    <section className="site-info__section">
                        <h2 className="site-info__title">Названия категорий</h2>
                        <form className="site-info__section" onSubmit={handleUpdateCategoryName}>
                            <label className="site-info__field">
                                <span>Категория</span>
                                <div className="order-header__select-wrapper">
                                    <select
                                        className="order-header__select"
                                        value={selectedCategoryId}
                                        onChange={(e) => handleSelectCategory(e.target.value, flatCategories)}
                                    >
                                        <option value="">Выберите категорию</option>
                                        {flatCategories.map((category) => (
                                            <option key={category.id} value={category.id}>
                                                {category.label}
                                            </option>
                                        ))}
                                    </select>
                                    <SelectChevron />
                                </div>
                            </label>
                            <label className="site-info__field">
                                <span>Множественное число</span>
                                <input
                                    type="text"
                                    value={categoryNamePlural}
                                    disabled={!selectedCategoryId}
                                    onChange={(e) => setCategoryNamePlural(e.target.value)}
                                />
                            </label>
                            <label className="site-info__field">
                                <span>Единственное число</span>
                                <input
                                    type="text"
                                    value={categoryNameSingular}
                                    disabled={!selectedCategoryId}
                                    onChange={(e) => setCategoryNameSingular(e.target.value)}
                                />
                            </label>
                            <button type="submit" className="order-button">
                                Сохранить названия
                            </button>
                        </form>
                    </section>

                    <section className="site-info__section">
                        <h2 className="site-info__title">Удаление категории</h2>
                        <form className="site-info__section" onSubmit={handleDeleteCategory}>
                            <label className="site-info__field">
                                <span>Категория</span>
                                <div className="order-header__select-wrapper">
                                    <select
                                        className="order-header__select"
                                        value={deleteCategoryId}
                                        onChange={(e) => setDeleteCategoryId(e.target.value)}
                                    >
                                        <option value="">Выберите категорию</option>
                                        {flatCategories.map((category) => (
                                            <option key={category.id} value={category.id}>
                                                {category.label}
                                            </option>
                                        ))}
                                    </select>
                                    <SelectChevron />
                                </div>
                            </label>
                            <button type="submit" className="order-button">
                                Удалить категорию
                            </button>
                        </form>
                    </section>

                    <section className="site-info__section">
                        <h2 className="site-info__title">Новая категория</h2>
                        <button
                            type="button"
                            className="order-button"
                            onClick={() => setAddNewCategoryIsOpen(!addNewCategoryIsOpen)}
                        >
                            {addNewCategoryIsOpen ? 'Скрыть форму' : 'Добавить новую категорию'}
                        </button>
                        {addNewCategoryIsOpen && (
                            <form className="site-info__section" onSubmit={handleAddCategory}>
                                <label className="site-info__field">
                                    <span>Название категории</span>
                                    <input
                                        type="text"
                                        value={newCategoryName}
                                        onChange={(e) => setNewCategoryName(e.target.value)}
                                        required
                                    />
                                </label>
                                <label className="site-info__field">
                                    <span>Родительская категория</span>
                                    <div className="order-header__select-wrapper">
                                        <select
                                            className="order-header__select"
                                            value={selectedParentCategory}
                                            onChange={(e) => setSelectedParentCategory(e.target.value)}
                                        >
                                            <option value="">Без родительской категории</option>
                                            {sortedCategories.map((category) => (
                                                <option
                                                    key={category.categoryId}
                                                    value={category.categoryId}
                                                >
                                                    {categoryOptionLabel(category.categoryName, category.productsNumber)}
                                                </option>
                                            ))}
                                        </select>
                                        <SelectChevron />
                                    </div>
                                </label>
                                <button type="submit" className="order-button">
                                    Создать категорию
                                </button>
                            </form>
                        )}
                    </section>
                </div>

                {/* Форма пользовательских названий */}
                <div className="stock__custom-inputs">
                    <label className="stock__form-label">
                        Введите названия складов через запятую:
                        <input
                            type="text"
                            className="stock__form-input"
                            value={customStockNames}
                            onChange={(e) => setCustomStockNames(e.target.value)}
                        />
                    </label>
                    <button type="button" className="button stock__form-button" onClick={sendCustomStockNames}>
                        Отправить на сервер
                    </button>
                </div>

                {/* Форма коэффициентов */}
                <div className="stock__custom-inputs">
                    <h3 className="stock__form-title">Коэффициенты складов</h3>
                    {customStockCoefs.map((item, idx) => (
                        <div key={idx} className="stock__coef-row">
                            <input
                                type="text"
                                placeholder="Название склада"
                                className="stock__form-input"
                                value={item.name}
                                onChange={(e) => handleChangeCoef(idx, 'name', e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="Коэффициент"
                                className="stock__form-input"
                                value={item.coef}
                                onChange={(e) => handleChangeCoef(idx, 'coef', e.target.value)}
                            />
                            <button
                                type="button"
                                className="button stock__form-button"
                                onClick={() => handleRemoveCoefRow(idx)}
                            >
                                <MinusIcon nameOfClass="stock__icon" />
                            </button>
                        </div>
                    ))}                    
                    <div className="stock__form-actions">
                        <button type="button" onClick={handleAddCoefRow}>
                            <PlusIcon nameOfClass="stock__icon" />
                        </button>
                        <button type="button" className="button stock__form-button" onClick={handleSendCoefs}>
                            Сохранить коэффициенты
                        </button>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error(error);
        return <ErrorHandler error={error} />;
    }
};
export default StocksTab;